import fetcher from 'api/fetcher';
import { getIndexByEntityId } from 'utils/clickme';
import { CampaignStatus } from 'utils/constants/dashboard';
import { NotificationName } from 'utils/constants/notification';

import urlParser from 'bloko/common/urlParser';

import { CampaignTabStatus, setCampaigns, setCheckedCampaignIds } from 'store/models/dashboard';
import { addNotification } from 'store/models/notification';
import { AppThunkAction } from 'store/utils';

export const updateCampaignStatus = (
    campaignId: number,
    tabStatus: CampaignTabStatus
): AppThunkAction<Promise<void | false>> => {
    return async (dispatch, getState) => {
        const state = getState();
        const { campaigns, checkedCampaignIds } = state.dashboard;

        const campaignIdx = getIndexByEntityId(campaignId, campaigns, 'id');

        if (campaignIdx === -1) {
            return false;
        }

        const newStatus = tabStatus === CampaignTabStatus.Active ? CampaignStatus.Blocked : CampaignStatus.Active;

        const queryStr = urlParser.stringify({
            newStatus,
            changeSource: 'CLICKME_CAMPAIGN_STATUS_TOGGLE',
        });

        return fetcher.put(`/api/v1/campaigns/${campaignId}/status?${queryStr}`).then(() => {
            const newCampaigns = [...campaigns];
            newCampaigns.splice(campaignIdx, 1);
            dispatch(setCampaigns(newCampaigns));

            const newCheckedCampaignIds = { ...checkedCampaignIds };
            delete newCheckedCampaignIds[campaignId];
            dispatch(setCheckedCampaignIds(newCheckedCampaignIds));

            if (tabStatus === CampaignTabStatus.Active) {
                dispatch(addNotification(NotificationName.CampaignChangeStatusToArchiveSuccess));
            } else {
                dispatch(addNotification(NotificationName.CampaignChangeStatusToActiveSuccess));
            }
        });
    };
};
